import axios from 'axios'
import {
    Message
} from 'element-ui'
console.log(process.env.BASE_URL)
// axios.defaults.baseURL = process.env.BASE_URL
// axios.defaults.baseURL = 'https://backend-test.wly.hn.cn'
axios.defaults.baseURL = 'https://backend.wlyuan.com.cn'
// axios.defaults.baseURL = 'http://192.168.1.30:8088'
// axios.defaults.baseURL = 'http://192.168.1.42:9002'
// axios.defaults.baseURL = 'http://192.168.1.236:9002'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
export default () => {
    axios.interceptors.request.use(config => {
        if (window.sessionStorage.getItem('token')) config.headers.common['Authorization'] = `Bearer ${window.sessionStorage.getItem('token')}`
        return config
    }, error => {
        return Promise.reject(error)
    })
    axios.interceptors.response.use(res => {
        return Promise.resolve(res)
    }, error => {
        if (error.response.data.code === -201) {
            // window.location.href = '/synchronization/Publish'
            Message({
                message: '系统错误，请稍后再试',
                type: 'warning'
            })
        } else if (error.response.status === 500) {
            Message({
                message: '系统错误，请稍后再试',
                type: 'warning'
            })
        }
        return Promise.reject(error)
    })
    return axios
}



// WEBPACK FOOTER //
// ./src/axios-init.js